var ensureAttachmentLightbox = function () {
  var $box = $('#attachment-lightbox');
  if ($box.length) return $box;

  $box = $(
    '<div id="attachment-lightbox" class="attachment-lightbox">' +
      '<div class="attachment-lightbox__bar">' +
        '<a class="attachment-lightbox__open" target="_blank" rel="noopener noreferrer"></a>' +
        '<button type="button" class="attachment-lightbox__close"><i class="fas fa-times" aria-hidden="true"></i></button>' +
      '</div>' +
      '<div class="attachment-lightbox__stage"></div>' +
    '</div>'
  );
  $('body').append($box);
  return $box;
};

var syncAttachmentLightbox = function ($slider) {
  var $media = $slider.find('.carousel-item.active .attachment-slider__media');
  var url = $media.data('url');
  var $open = $('#attachment-lightbox .attachment-lightbox__open');

  if (url) {
    $open.attr('href', url).show();
  } else {
    $open.removeAttr('href').hide();
  }

  $slider.find('.attachment-slider__pdf').remove();
  $slider.find('.attachment-slider__file-card').show();

  if ($media.data('kind') === 'pdf' && url) {
    $media.find('.attachment-slider__file-card').hide();
    $media.append(
      $('<iframe>', {
        class: 'attachment-slider__pdf',
        src: url,
        title: $media.find('.attachment-slider__filename').text()
      })
    );
  }
};

var openAttachmentLightbox = function ($slider) {
  if (!$slider.length || $slider.hasClass('is-fullscreen')) return;

  var $box = ensureAttachmentLightbox();
  var $placeholder = $('<div class="attachment-slider__placeholder"></div>').height($slider.outerHeight());
  $slider.before($placeholder);
  $slider.data('lightbox-placeholder', $placeholder);
  $slider.find('img[data-full-src]').each(function () {
    this.src = this.dataset.fullSrc;
  });
  $box.find('.attachment-lightbox__open').text($slider.data('open-label') || '');
  $box.find('.attachment-lightbox__close').attr('aria-label', $slider.data('close-label') || 'Close');
  $box.find('.attachment-lightbox__stage').append($slider);
  $slider.addClass('is-fullscreen');
  syncAttachmentLightbox($slider);
  $box.addClass('is-open');
  $('body').addClass('attachment-lightbox-open');
  $box.find('.attachment-lightbox__close').trigger('focus');
};

var closeAttachmentLightbox = function () {
  var $slider = $('#attachment-lightbox .attachment-slider');
  if (!$slider.length) return;

  $slider.find('video').each(function () { this.pause(); });
  $slider.find('.attachment-slider__pdf').remove();
  $slider.find('.attachment-slider__file-card').show();
  $slider.find('img[data-thumb-src]').each(function () {
    this.src = this.dataset.thumbSrc;
  });
  $slider.removeClass('is-fullscreen');

  var $placeholder = $slider.data('lightbox-placeholder');
  if ($placeholder) {
    $placeholder.replaceWith($slider);
    $slider.removeData('lightbox-placeholder');
  }

  $('#attachment-lightbox').removeClass('is-open');
  $('body').removeClass('attachment-lightbox-open');
};

$(document).on('click', '.attachment-slider:not(.is-fullscreen) .attachment-slider__media', function (event) {
  if ($(event.target).closest('video').length) return;
  event.preventDefault();
  openAttachmentLightbox($(this).closest('.attachment-slider'));
});

$(document).on('keydown', '.attachment-slider:not(.is-fullscreen) .attachment-slider__media', function (event) {
  if (event.key !== 'Enter' && event.key !== ' ') return;
  if ($(event.target).closest('video').length) return;
  event.preventDefault();
  openAttachmentLightbox($(this).closest('.attachment-slider'));
});

$(document).on('click', '.attachment-slider__expand', function (event) {
  event.preventDefault();
  event.stopPropagation();
  openAttachmentLightbox($(this).closest('.attachment-slider'));
});

$(document).on('click', '.attachment-lightbox__close', function () {
  closeAttachmentLightbox();
});

$(document).on('click', '#attachment-lightbox', function (event) {
  if (event.target.id === 'attachment-lightbox') closeAttachmentLightbox();
});

$(document).on('keydown', function (event) {
  var $slider = $('#attachment-lightbox .attachment-slider.is-fullscreen');
  if (!$slider.length) return;

  if (event.key === 'Escape') {
    event.preventDefault();
    closeAttachmentLightbox();
  } else if (event.key === 'ArrowRight') {
    event.preventDefault();
    $slider.carousel('next');
  } else if (event.key === 'ArrowLeft') {
    event.preventDefault();
    $slider.carousel('prev');
  }
});

$(document).on('slide.bs.carousel', '.attachment-slider', function () {
  $(this).find('video').each(function () {
    this.pause();
  });
});

$(document).on('slid.bs.carousel', '.attachment-slider', function () {
  var $slider = $(this);
  var total = $slider.find('.carousel-item').length;
  var current = $slider.find('.carousel-item').index($slider.find('.carousel-item.active')) + 1;
  var template = $slider.data('position-template');

  if (!template) return;

  $slider.find('.attachment-slider__count').text(
    template.replace('__CURRENT__', current).replace('__TOTAL__', total)
  );

  if ($slider.hasClass('is-fullscreen')) syncAttachmentLightbox($slider);
});

var loadingOlderActivities = false;

var hashedNoteId = function () {
  var match = (window.location.hash || '').match(/^#note-item-(\d+)$/);
  return match ? match[1] : null;
};

var scrollToHashedNote = function () {
  var noteId = hashedNoteId();
  if (!noteId) return false;

  var target = document.getElementById('note-item-' + noteId);
  if (!target) return false;

  target.scrollIntoView({ block: 'center' });
  target.classList.add('note-item--focused');
  return true;
};

var fetchOlderActivities = function () {
  var $loadMore = $('.load-more');
  var lastId = $('.root-activity').last().attr('data-id');
  if (loadingOlderActivities || !$loadMore.length || !lastId) {
    return $.Deferred().reject().promise();
  }

  loadingOlderActivities = true;
  $loadMore.hide();
  $('.ajax-spinner').show();

  return $.ajax({
    type: 'GET',
    url: $loadMore.attr('href'),
    data: { id: lastId },
    dataType: 'script'
  }).always(function () {
    loadingOlderActivities = false;
    $('.ajax-spinner').hide();
    $loadMore.show();
  });
};

// The feed renders a page at a time. A notification hash for an older post is
// not in the document until those pages are loaded, and #application is the
// scroll container, so the browser will not land on it by itself.
var revealHashedNote = function () {
  if (scrollToHashedNote()) return;
  if (!hashedNoteId()) return;
  if (new URLSearchParams(window.location.search).has('focus_note_id')) return;

  var attempts = 0;
  var loadNext = function () {
    if (attempts >= 40) return;
    attempts += 1;

    var before = $('.root-activity').length;
    fetchOlderActivities().done(function () {
      if (scrollToHashedNote()) return;
      if ($('.root-activity').length <= before) return;
      loadNext();
    });
  };

  loadNext();
};

$(document).ready(function () {
  $('.load-more').click(function (e) {
    e.preventDefault();
    fetchOlderActivities();
  });

  revealHashedNote();
});

$(window).on('load', function () {
  if (hashedNoteId() && document.getElementById('note-item-' + hashedNoteId())) {
    scrollToHashedNote();
  }
});
